<template>
  <div class="c-history p-1">
    <slot name="title" />
    <div v-if="!titleHide" class="c-history-nav">
      {{ title ? title : i18n('history') }}
    </div>
    <app-timeline>
      <!-- 12 INVOICES HAVE BEEN PAID -->
      <template v-for="(item, i) in data">
        <app-timeline-item :key="i" :variant="item.variant">
          <div class="d-flex justify-content-between">
            <span class="title-text">{{ item.title }}</span>
            <span class="tip-text">{{ item.tip }}</span>
          </div>

          <p class="info-text">
            {{ item.info }}
          </p>
          <p class="m-0">
            <slot />
          </p>

          <p class="info-remark">
            {{ item.remark }}
          </p>
        </app-timeline-item>
      </template>
    </app-timeline>
  </div>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  BImg,
  BAvatar,
  BMedia,
  BButton,
  BCollapse,
  VBToggle,
  BListGroup,
  BListGroupItem,
  BAvatarGroup,
  BBadge,
  VBTooltip,
  Ripple,
} from 'bootstrap-vue'

export default {
  name: 'CHistory',
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
    titleHide: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.history.${param}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-history {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  &-nav {
    color: var(--Color-Text-text-color-primary, #303133);

    /* bold/medium */
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 150% */
    margin-bottom: 16px;
  }
}
.title-text {
  color: var(--Color-Text-text-color-primary, #303133);

  /* bold/medium */
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}
.tip-text {
  color: var(--Color-Text-text-color-secondary, #909399);
  text-align: right;

  /* regular/extra-small */
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}
.info-text {
  color: #303133;

  /* medium/base */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  margin-bottom: 8px;
}
.info-remark {
  color: var(--Color-Text-text-color-secondary, #909399);
  /* regular/base */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}
</style>
